import Service from '@ember/service';
import { isTesting, macroCondition } from '@embroider/macros';
import Cookies from 'js-cookie';

export default class CookieService extends Service {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getCookie(name: string) {
    const cookieValue = Cookies.get(name);
    if (cookieValue) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return JSON.parse(cookieValue);
    }
    return null;
  }

  resetCookie(name: string): void {
    Cookies.remove(name);
  }

  setCookie(name: string, obj: string): void {
    if (macroCondition(isTesting())) {
      return;
    }

    Cookies.set(name, obj, { expires: 365 });
  }
}

declare module '@ember/service' {
  interface Registry {
    cookie: CookieService;
  }
}
